export default () => {
  const wishlists = document.querySelectorAll('.js-wishlist')
  if (wishlists.length < 1) return
  ;[...wishlists].forEach(wishlist => {
    wishlist.addEventListener('click', e => {
      wishlist.classList.add('loading')
      wishlist.classList.remove('active')

      window
        .fetch(
          `/wordpress/wp-admin/admin-ajax.php?action=${
            wishlist.dataset.action
          }_favorites`,
          {
            credentials: 'same-origin',
            method: 'post',
            body: JSON.stringify({
              id: wishlist.dataset.id,
              type: wishlist.dataset.type
            })
          }
        )
        .then(response => {
          return response.json()
        })
        .then(r => {
          console.log(r)
          wishlist.classList.remove('loading')
          wishlist.classList.add('success')
          window.setTimeout(() => {
            wishlist.classList.remove('success')
            if (wishlist.dataset.action === 'add') {
              wishlist.classList.add('active')
              wishlist.dataset.action = 'remove'
            } else {
              wishlist.dataset.action = 'add'
            }
          }, 1000)
        })
    })
  })
}



// WEBPACK FOOTER //
// ./src/js/modules/Wishlist.js